import { useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useParams } from 'react-router-dom';
import { Container } from 'yoso';
import { LoginSecurity } from '~/components/Auth/Login/Security/LoginSecurity';
import { QueryErrorBoundary } from '~/components/Error';
import { useFlag } from '~/components/Flag';
import { LandCardList } from '~/components/Land/Card/List';
import { LandEventGuide } from '~/components/Land/Event/Guide/LandEventGuide';
import { LandEventHero } from '~/components/Land/Event/Hero/LandEventHero';
import { useLatestLandEvent } from '~/components/Land/Event/LandEvent.hooks';
import { LandEventWinner } from '~/components/Land/Event/Winner/LandEventWinner';
import { LandStatusBar } from '~/components/Land/StatusBar/LandStatusBar';
import { Page } from '~/components/Page';
import { Section } from '~/components/Page/Section/Section';
import { HashScroll } from '~/components/Route/Scroll/HashScroll';
import { StatusBarErrorFallback } from '~/components/Status/Bar/ErrorFallback/StatusBarErrorFallback';
import styles from './LandEventPage.module.scss';

export const LandEventPage = () => {
  const latestEvent = useLatestLandEvent();
  const { week } = useParams<{ week: string }>();
  const { hide: hideLandWeek } = useFlag({ name: 'LAND_WEEK', value: latestEvent?.week });
  const id = Number(week);

  useEffect(() => {
    hideLandWeek();
  }, [hideLandWeek]);
  return (
    <Page className={styles.root} data-event-page_name="Land">
      <Container margin="auto">
        <Section className={styles.pageSection}>
          <Section>
            <LandEventHero id={id} />
            <ErrorBoundary
              fallbackRender={(props) => (
                <StatusBarErrorFallback {...props} className={styles.statusBar} />
              )}>
              <LoginSecurity>
                <LandStatusBar id={id} className={styles.statusBar} />
              </LoginSecurity>
            </ErrorBoundary>
          </Section>
          <Section>
            <LandEventGuide />
          </Section>
          <HashScroll hash="#join" behavior="smooth" position="start">
            <Section className={styles.landListSection}>
              <LandCardList id={id} />
            </Section>
          </HashScroll>
          <Section>
            <QueryErrorBoundary>
              <LandEventWinner />
            </QueryErrorBoundary>
          </Section>
        </Section>
      </Container>
    </Page>
  );
};
